import { gql } from '@apollo/client'

export const FrgTicketForTable = gql`
  fragment FrgTicketForTable on TicketDef {
    id
    description
    createdAt
    ticketType {
      id
      name
    }
    location {
      id
      name
    }
    status
    priority
    property {
      id
      type {
        id
        name
      }
      externalPropertyNumber
      location {
        id
        name
      }
    }
    agreement {
      id
      startDate
      endDate
      property {
        id
      }
    }
    container {
      id
      containerId
      location {
        id
        name
      }
      containerType {
        id
        name
      }
      wasteFraction {
        id
        name
        color
        icon
        iconPreset
      }
    }
    assignee {
      id
      firstName
      lastName
    }
    statusOpenAt
    statusRejectedAt
    statusCompletedAt
    statusPendingAt
    statusOnHoldAt
    statusInProgressAt
    preferredDate
  }
`
